var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1728,
    viewBox: "0 0 1440 1728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1544.2 1016.65C1510.43 1016.65 1477.25 1018.68 1444.66 1023.05C1068.62 1067.87 770.289 1365.91 725.758 1741.95C721.683 1771.05 719.937 1800.74 719.646 1830.72V1851.97C719.354 1848.47 719.354 1844.69 719.354 1841.2C719.354 1807.43 717.317 1774.25 712.951 1741.66C668.129 1365.62 370.092 1067.87 -5.65668 1023.05C-38.2545 1018.68 -71.4345 1016.65 -105.197 1016.65C-71.4345 1016.65 -38.2545 1014.61 -5.65668 1010.24C370.383 965.42 680.936 668.547 712.951 291.343C716.153 253.507 718.772 177.833 719.646 139.996C720.519 105.07 719.646 0 719.646 0C712.078 0 704.22 0 696.652 0.291052C154.131 12.2242 -284.776 451.422 -296.709 993.944C-297 1001.51 -297 1009.08 -297 1016.65C-297 1024.21 -297 1031.78 -296.709 1039.35C-284.776 1581.58 154.131 2020.78 696.652 2032.71C704.22 2033 712.078 2033 719.646 2033C727.213 2033 734.489 2033 742.057 2032.71C1284.58 2021.07 1723.78 1581.87 1735.71 1039.35C1736 1031.78 1736 1024.21 1736 1016.65H1544.2Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.646 1830.72C719.354 1834.21 719.354 1837.7 719.354 1841.2C719.354 1844.69 719.354 1848.47 719.646 1851.97V1830.72Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.07 817.857C1552.92 817.857 1736 634.773 1736 408.928C1736 183.084 1552.92 0 1327.07 0C1101.23 0 918.143 183.084 918.143 408.928C918.143 634.773 1101.23 817.857 1327.07 817.857Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2033,
    height: 1728,
    fill: "white",
    transform: "translate(-297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCBg);
export default __webpack_public_path__ + "static/media/c-bg.4918625bc197fe93f789cd5fce1aad52.svg";
export { ForwardRef as ReactComponent };